
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const reactPlugin = new ReactPlugin();

const browserHistory = createBrowserHistory();

/*const appInsights = new ApplicationInsights({
  config: {
    connectionString: 'InstrumentationKey=80a21c28-c3c5-4d4c-888a-73e8b882ecd2;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=bb9f16c7-745b-4178-934c-633cbb7da5be', 
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true, 
    enableCorsCorrelation: true, 
    enableRequestHeaderTracking: true, 

    excludeRequestFromAutoTrackingPatterns: [
      /cdn-api-weglot\.com/i,
      /api\.weglot\.com/i,
    ],
  }
});

appInsights.loadAppInsights(); */


export {reactPlugin, browserHistory };
